export enum ReportStatus {
    S = 'Submitted',
    E = 'Executing',
    C = 'Completed',
    F = 'Failed',
}